module Meevo.Plugins.GiftCardBalance {
    export class GiftCardBalanceContext extends Meevo.Components.CommonClasses.CommonContextBase {
        initializeSections(): void { }
        initializeHeader(): void { }
    }
}